import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useModal } from 'hooks/UI';
import { BurgerWrapper } from '../BurgerButton';
import { Drawer } from '../Drawer';
import { DrawerContent } from '../DrawerContent';
export const MobileHeader = () => {
    const [isDrawerOpen, openDrawer, closeDrawer] = useModal();
    return (_jsxs(_Fragment, { children: [_jsx(BurgerWrapper, { openDrawer: openDrawer }), _jsx(Drawer, Object.assign({ isDrawerOpen: isDrawerOpen, closeDrawer: closeDrawer }, { children: _jsx(DrawerContent, { closeDrawer: closeDrawer }) }))] }));
};
